import React, { useEffect, useState } from "react";
import "./single.scss";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Chart from "../../components/Chart";
import Table from "../../components/Table";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { useParams } from "react-router-dom";

const Single = () => {
  const { id } = useParams();
  const [user, setUser] = useState({});

  useEffect(() => {
    const docRef = doc(db, "users", id);
    onSnapshot(docRef, (doc) => {
      console.log(doc.data(), doc.id);
      setUser(doc.data());
    });
  }, [id]);
  console.log(user);

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <h1 className="title">Information</h1>
            <div className="item">
              <div className="editButton">Edit</div>
              <img src={user.img} alt="" />
              <div className="details">
                <h1 className="title">{user.username}</h1>
                <div className="detailItem">
                  <div className="itemKey">Email:</div>
                  <div className="itemValue">{user.email}</div>
                </div>
                <div className="detailItem">
                  <div className="itemKey">Phone:</div>
                  <div className="itemValue">{user.phone}</div>
                </div>
                <div className="detailItem">
                  <div className="itemKey">Address:</div>
                  <div className="itemValue">{user.address}</div>
                </div>
                <div className="detailItem">
                  <div className="itemKey">Country:</div>
                  <div className="itemValue">{user.country}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <Chart aspect={3 / 1} title="User Spending (Last 6 Months)" />
          </div>
        </div>
        <div className="bottom">
          <h1 className="title">Last Transactions</h1>
          <Table />
        </div>
      </div>
    </div>
  );
};

export default Single;
